// Path: src/Screens/admin/RentalRequest/RentalRequest.jsx

import React, { useState, useMemo, useEffect, useContext } from "react";
import {
  FiMoreVertical, FiTrash2, FiEye, FiEdit, FiSearch, FiX,
  FiClock, FiActivity, FiCheckCircle, FiHash, FiCalendar,
  FiUser, FiMapPin, FiDollarSign, FiAlertCircle
} from "react-icons/fi";
import { MdRequestPage, MdPending, MdCheckCircle } from "react-icons/md";
import { GiFarmTractor } from "react-icons/gi";
import { FaFileAlt } from 'react-icons/fa';
 
import { Row, Col, Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import AppPagination from "../../../components/general/pagination/Pagination.js";
import RentalAdminLayout from "../../../layout/equipmentrentaladmin/RentalAdminLayout.js";
import '../../../assets/css/equipmentrentaladmin/rentals/Rentals.css';
import AppContext from "../../../context/AppContext.js";
import axios from "axios";

// ── Tab config ──
const TABS = [
  { key: "pending", label: "Requested", icon: <FiClock size={14} /> },
  { key: "inprogress", label: "In Progress", icon: <FiActivity size={14} /> },
  { key: "completed", label: "Completed", icon: <FiCheckCircle size={14} /> },
  { key: "cancelled", label: "Cancelled", icon: <FiX size={14} /> },
];

// ── Duration ko sahi unit (Hour/Day/Acre) ke sath dikhane ke liye ──
function formatDuration(duration, rentalbasis) {
  const basis = rentalbasis || "hour";
  const labels = {
    hour: "Hour(s)",
    day: "Day(s)",
    acre: "Acre(s)",
  };
  return `${duration || 0} ${labels[basis] || "Hour(s)"}`;
}

const RentalRequest = () => {
  const { baseUrl, loggedInRental, baseUrlForFile , authToken} = useContext(AppContext);

  const [activeDropdown, setActiveDropdown] = useState(null);
  const [statusModal, setStatusModal] = useState(null);
  const [activeFilter, setActiveFilter] = useState("requested");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const requestsPerPage = 5;

  const [requests, setRequests] = useState([]);

  const viewMyRentalRequests = () => {
    if (!loggedInRental) return;
    axios.post(`${baseUrl}/rentaladmin/rentalrequest/viewMyRentalRequests`,
        {
          srrentaladmin_id: loggedInRental.id,
        } , {
      headers: { Authorization: `Bearer ${authToken}` }
    }
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setRequests(res.data.request);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

useEffect(() => {
  if (loggedInRental?.id) {
    viewMyRentalRequests();
  }
}, [loggedInRental]);

  // ── Stats ──
  const stats = useMemo(() => {
    const data = Array.isArray(requests) ? requests : [];

    return {
      pending: data.filter(r => r.status === "pending").length,
      inprogress: data.filter(r => r.status === "inprogress").length,
      completed: data.filter(r => r.status === "completed").length,
      cancelled: data.filter(r => r.status === "cancelled").length,
    };
  }, [requests]);

const statsData = [
  {
    id: 1,
    icon: <FaFileAlt />,
    count: stats.pending,
    label: "Requested"
  },
  {
    id: 2,
    icon: <MdPending />,
    count: stats.inprogress,
    label: "In Progress"
  },
  {
    id: 3,
    icon: <MdCheckCircle />,
    count: stats.completed,
    label: "Completed"
  }
];

  // ── Filter + Search ──
  const filteredRequests = useMemo(() => {
    const data = Array.isArray(requests) ? requests : [];

    let filtered = data.filter(r => {
      if (activeFilter === "requested") {
        return r.status === "pending";
      }

      return r.status === activeFilter;
    });

    return filtered;
  }, [requests, activeFilter, searchTerm]);

  const totalPages = Math.ceil(filteredRequests.length / requestsPerPage);
  const indexOfLastRequest = currentPage * requestsPerPage;
  const indexOfFirst = indexOfLastRequest - requestsPerPage;
  const currentRequests = filteredRequests.slice(indexOfFirst, indexOfLastRequest);

  useEffect(() => { setCurrentPage(1); }, [activeFilter, searchTerm]);

  useEffect(() => {
    const close = (e) => {
      if (!e.target.closest(".rrm-dropdown-wrapper")) setActiveDropdown(null);
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // ✅ View Detail Modal
  const handleView = (req) => {
    setSelectedRequest(req);
    setShowModal(true);
    setActiveDropdown(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRequest(null);
  };

  const handleStatusUpdate = (id, status) => {

    const formData = new FormData();
    formData.append("id", id);
    formData.append("status", status);

    axios.post(
      `${baseUrl}/rentaladmin/rentalrequest/updateStatus`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`
        },
      }
    )
      .then((res) => {

        if (res.data.success === true) {

          setStatusModal(null);

          Swal.fire({
            title: "Updated!",
            text: "Rental status updated successfully.",
            icon: "success",
            confirmButtonColor: "#FDB714"
          });

          viewMyRentalRequests();
        } else {
          setStatusModal(null);
          Swal.fire({
            title: "Could not update",
            text: res.data.message,
            icon: "error",
          });
        }

      })
      .catch((err) => {
        console.log(err);
      });
  };

  // ── Cancel Booking — rental admin khud cancel kar sakta hai ──
  const handleCancelBooking = (req) => {
    setActiveDropdown(null);
    Swal.fire({
      icon: "warning",
      title: "Cancel This Booking?",
      text: "Are you sure you want to cancel this booking? This action cannot be undone.",
      showCancelButton: true,
      confirmButtonColor: "#e8590c",
      cancelButtonColor: "#aaa",
      confirmButtonText: "Yes, Cancel Booking",
      cancelButtonText: "No, Keep Booking",
    }).then((result) => {
      if (!result.isConfirmed) return;

      axios
        .post(
          `${baseUrl}/rentaladmin/rentalrequest/cancelBooking`,
          {
            booking_id: req.id,
            srrentaladmin_id: loggedInRental.id,
          },
          { headers: { Authorization: `Bearer ${authToken}` } },
        )
        .then((res) => {
          if (!res.data.success) {
            Swal.fire({ icon: "error", title: "Could not cancel", text: res.data.message });
            return;
          }
          Swal.fire({ icon: "success", title: "Booking Cancelled", confirmButtonColor: "#FDB714" });
          viewMyRentalRequests();
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({ icon: "error", title: "Error", text: "Something went wrong while cancelling the booking." });
        });
    });
  };

  const handleDelete = (req) => {
    Swal.fire({
      title: "Delete Rental Request?",
      text: `Request by ${req.rentername}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545"
    }).then(result => {
      if (result.isConfirmed) {
        setRequests(prev => prev.filter(r => r.id !== req.id));
        Swal.fire("Deleted!", "Request removed.", "success");
      }
    });
    setActiveDropdown(null);
  };

  const statusClass = (status) => {
    if (status === "pending") return "rrm-status-requested";
    if (status === "inprogress") return "rrm-status-inprogress";
    if (status === "completed") return "rrm-status-completed";
    if (status === "cancelled") return "rrm-status-cancelled";
    return "";
  };

  const getStatusLabel = (status) => {
    if (status === "pending") return "Requested";
    if (status === "inprogress") return "In Progress";
    if (status === "completed") return "Completed";
    if (status === "cancelled") return "Cancelled";
    return status;
  };
  const getModalStatusClass = (status) => {
    if (status === "pending") return "rrm-modal-badge-requested";
    if (status === "inprogress") return "rrm-modal-badge-inprogress";
    if (status === "completed") return "rrm-modal-badge-completed";
    if (status === "cancelled") return "rrm-modal-badge-cancelled";
    return "";
  };



  // ================================================================
  // RETURN
  // ================================================================
  return (



    <RentalAdminLayout>
      <div className="rd-page">

        {/* ── Stat Cards ── */}
        <div className="dashboard-stats-container">
          <Row className="g-4 mb-4">
            {statsData.map((stat) => (
              <Col key={stat.id} xl={4} lg={4} md={6} sm={12}>
                <div className="stat-card" style={{ borderLeft: '4px solid #FDB714' }}>
                  <div className="stat-icon">{stat.icon}</div>
                  <div className="stat-content">
                    <h3>{stat.count}</h3>
                    <p>{stat.label}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        {/* ── Header ── */}
        <div className="rrm-header">
          <h1 className="rrm-title">All Rental Requests</h1>
        </div>

        {/* ✅ OUTER TABS — PayoutsManagement style */}
        <div className="rrm-outer-tabs-wrap">
          <div className="rrm-outer-tabs">
            {TABS.map((tab) => (
              <button
                key={tab.key}
                className={`rrm-outer-tab ${activeFilter === tab.key ? "rrm-outer-tab-active" : ""}`}
                onClick={() => { setActiveFilter(tab.key); setCurrentPage(1); }}
              >
                {tab.icon}
                {tab.label}
                <span className="rrm-outer-tab-count">({stats[tab.key]})</span>
              </button>
            ))}
          </div>
        </div>

        {/* ✅ TABLE CARD — PayoutsManagement style */}
        <div className="rrm-table-card">

          {/* Dynamic heading */}
          <div className="rrm-table-heading">
            <h2 className="rrm-table-title">
              {activeFilter === "requested" && "Requested Rentals"}
              {activeFilter === "inprogress" && "In Progress Rentals"}
              {activeFilter === "completed" && "Completed Rentals"}
              {activeFilter === "cancelled" && "Cancelled Rentals"}
            </h2>
          </div>

          {/* Table */}
          <div className="rrm-table-wrapper">
            <table className="rrm-table">
              <thead>
                <tr>
                  <th>Customer </th>
                  <th>EQUIPMENT </th>
                  <th>DATE</th>
                  <th>DURATION</th>
                  <th>LOCATION</th>
                  <th>STATUS</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {currentRequests.length > 0 ? (
                  currentRequests.map(req => (
                    <tr key={req.id}>
                      <td>
                        <div className="rrm-seller-cell">
                          <img
                            src={`${baseUrlForFile}/${req.srcustomer?.image}`}
                            alt={req.srcustomer?.fullname}
                            className="rrm-seller-avatar"
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                          <div className="rrm-seller-info">
                            <div className="rrm-seller-name">
                              {req.srcustomer?.fullname || "N/A"}
                            </div>
                            <div className="rrm-seller-email">
                              {req.srcustomer?.email || ""}
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        {req.srequipmentmanagment?.equipmentname || "N/A"}
                      </td>

                      <td>{req.bookingdate || "N/A"}</td>

                      <td>{formatDuration(req.duration, req.rentalbasis)}</td>

                      <td>{req.location || "N/A"}</td>
                      <td>
                        <span className={`rrm-status ${statusClass(req.status)}`}>
                          {getStatusLabel(req.status)}
                        </span>
                      </td>
                      <td>
                        <div className="rrm-dropdown-wrapper">
                          <button className="rrm-dots-btn" onClick={() => setActiveDropdown(req.id)}>
                            <FiMoreVertical />
                          </button>
                          {activeDropdown === req.id && (
                            <div className="rrm-dropdown">
                              <button onClick={() => handleView(req)}>
                                <FiEye /> View
                              </button>
                              {!["completed", "cancelled"].includes(req.status) && (
                                <button
                                  onClick={() => {
                                    setStatusModal(req);
                                    setActiveDropdown(null);
                                  }}
                                >
                                  <FiEdit /> Update
                                </button>
                              )}
                              {!["completed", "cancelled"].includes(req.status) && (
                                <button
                                  style={{ color: "#e8590c" }}
                                  onClick={() => handleCancelBooking(req)}
                                >
                                  <FiX /> Cancel Booking
                                </button>
                              )}
                              <button onClick={() => handleDelete(req)}>
                                <FiTrash2 /> Delete
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="rrm-empty-row">
                      No rental requests found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <AppPagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={filteredRequests.length}
            itemsPerPage={requestsPerPage}
            onPageChange={handlePageChange}
          />
        </div>

        {/* ✅ VIEW DETAIL MODAL — PayoutsManagement style */}
        <Modal show={showModal} onHide={handleCloseModal} centered size="lg" className="rrm-detail-modal">
          {selectedRequest && (
            <>
              {/* Black Header */}
              <div className="rrm-modal-header">
                <div className="rrm-modal-header-left">
                  <h5>Rental Request Detail</h5>
                  <span>Full breakdown of this rental request</span>
                </div>
                <button className="rrm-modal-close" onClick={handleCloseModal}>
                  <FiX />
                </button>
              </div>

              <Modal.Body className="rrm-modal-body">

                {/* Status Bar */}
                <div className="rrm-modal-status-bar">
                  <div className="rrm-sb-left">
                    <FiHash size={15} color="#FDB714" />
                    <span className="rrm-sb-id">REQ-{selectedRequest.id.toString().padStart(3, '0')}</span>
                    <span className={`rrm-modal-badge ${getModalStatusClass(selectedRequest.status)}`}>
                      <span className="rrm-modal-badge-dot"></span>
                      {getStatusLabel(selectedRequest.status)}
                    </span>
                  </div>
                  <div className="rrm-sb-date">
                    <FiCalendar size={13} />
                    {selectedRequest.bookingdate || "N/A"}
                  </div>
                </div>

                {/* Renter Information */}
                <p className="rrm-section-title"><FiUser size={14} /> Renter Information</p>
                <div className="rrm-modal-renter-strip">
                  <img
                    src={`${baseUrlForFile}/${selectedRequest.srcustomer?.image}`}
                    alt={selectedRequest.srcustomer?.fullname}
                    className="rrm-renter-avatar-img"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                  <div className="rrm-renter-info">
                    <div className="rrm-renter-name">
                      {selectedRequest.srcustomer?.fullname || "N/A"}
                    </div>
                    <div className="rrm-renter-owner">
                      {selectedRequest.srcustomer?.email || `Customer ID: ${selectedRequest.srcustomer_id || "N/A"}`}
                    </div>
                  </div>
                  <span className={`rrm-modal-badge ${getModalStatusClass(selectedRequest.status)}`}>
                    <span className="rrm-modal-badge-dot"></span>
                    {getStatusLabel(selectedRequest.status)}
                  </span>
                </div>

                {/* Request Details Grid */}
                <p className="rrm-section-title"><FiHash size={14} /> Request Details</p>
                <div className="rrm-info-grid">
                  <div className="rrm-info-item">
                    <label>Request ID</label>
                    <span className="rrm-info-id">REQ-{selectedRequest.id.toString().padStart(3, '0')}</span>
                  </div>
                  <div className="rrm-info-item">
                    <label>Equipment</label>
                    <span>
                      {selectedRequest.srequipmentmanagment?.equipmentname || "N/A"}
                    </span>
                  </div>
                  <div className="rrm-info-item">
                    <label>Duration</label>
                    <span>{formatDuration(selectedRequest.duration, selectedRequest.rentalbasis)}</span>
                  </div>
                  <div className="rrm-info-item">
                    <label>Rental Date</label>
                    <span>{selectedRequest.bookingdate || "N/A"}</span>
                  </div>
                </div>

                {/* Location */}
                <p className="rrm-section-title"><FiMapPin size={14} /> Location Details</p>
                <div className="rrm-location-box">
                  <FiMapPin size={16} color="#FDB714" />
                  <span>{selectedRequest.location}</span>
                </div>

                {/* Financial Breakdown */}
                {/* Financial Breakdown */}
                <p className="rrm-section-title">
                  <FiDollarSign size={14} /> Financial Breakdown
                </p>

                <div className="rrm-financials-box">
                  <div className="rrm-fin-row">
                    <span>Total Price</span>
                    <span className="rrm-fin-pos">
                      Rs. {Number(selectedRequest.totalprice || 0).toLocaleString()}
                    </span>
                  </div>

                  <div className="rrm-fin-row rrm-fin-total">
                    <span>Amount Payable</span>
                    <span>
                      Rs. {Number(selectedRequest.totalprice || 0).toLocaleString()}
                    </span>
                  </div>
                </div>

              </Modal.Body>

            </>
          )}
        </Modal>

      </div>
      {statusModal && (
        <div className="mr-overlay" onClick={() => setStatusModal(null)}>
          <div
            className="mr-modal mr-modal-sm"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="mr-modal-header">
              <div className="mr-modal-header-left">
                <h5>Update Status</h5>
                <span>
                  {statusModal.rentername} — Rental Request
                </span>
              </div>

              <button
                className="mr-modal-close"
                onClick={() => setStatusModal(null)}
              >
                <FiX />
              </button>
            </div>

            <div className="mr-modal-body">

              <p className="mr-status-prompt">
                Current:&nbsp;
                <span className={`rrm-status ${statusClass(statusModal.status)}`}>
                  {getStatusLabel(statusModal.status)}
                </span>
              </p>

              <div className="mr-status-options">
                <button
                  className={`mr-status-option ${statusModal.status === "inprogress"
                    ? "mr-status-current"
                    : ""
                    }`}
                  onClick={() =>
                    handleStatusUpdate(statusModal.id, "inprogress")
                  }
                  disabled={statusModal.status === "inprogress"}
                >
                  <FiActivity size={18} />
                  <span>In Progress</span>
                </button>

                <button
                  className={`mr-status-option mr-status-done ${statusModal.status === "completed"
                    ? "mr-status-current"
                    : ""
                    }`}
                  onClick={() =>
                    handleStatusUpdate(statusModal.id, "completed")
                  }
                  disabled={statusModal.status === "completed"}
                >
                  <FiCheckCircle size={18} />
                  <span>Completed</span>
                </button>

              </div>

            </div>

          </div>
        </div>
      )}
    </RentalAdminLayout>
  );
};

export default RentalRequest;